import { Button, Input, Modal, Select } from 'antd'
import React, { useEffect } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'

import { getUserId } from '../../helpers/auth'
import Loader from '../../pages/pages/loader'
import {
  useCreateMessageMutation,
  useUpdateMessageMutation
} from '../../redux/apis/domainsManagement/vrdMessages/dMVrdMessagesApiSlice'

const EditCreateDomainVRDModal = ({
  vrd,
  open,
  setOpen,
  isEdit = false,
  setHolder,
  setIsEdit
}) => {
  const [create, { isLoading, isSuccess, error }] = useCreateMessageMutation()
  const [
    update,
    { isLoading: updateLoading, isSuccess: updateSuccess, error: updateError }
  ] = useUpdateMessageMutation()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      msg: vrd?.msg || '',
      is_active: isEdit ? (vrd?.is_active ? true : false) : true,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      msg: Yup.string().required('Please Enter Campaign Keyword '),
      is_active: Yup.boolean().required('Please Select Campaign Status')
    }),

    onSubmit: async values => {
      try {
        if (isEdit) {
          await update({ id: vrd?.id, body: values }).unwrap()
        } else {
          await create(values)
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (updateError?.data) {
      const errorMessages = Object.values(updateError.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error, updateError])

  useEffect(() => {
    if (isSuccess) {
      toast.success('Domain VRD message Added!')
      setOpen(false)
      validation.resetForm()
    } else if (updateSuccess) {
      toast.success('Domain VRD message Updated!')
      setOpen(false)
      validation.resetForm()
    }
  }, [isSuccess, updateSuccess])
  return (
    <>
      <Loader isLoading={isLoading || updateLoading} />
      <div className='flex w-full justify-end'>
        <button
          className='btn btn-outline-theme mb-4'
          onClick={() => {
            setHolder()
            setIsEdit(false)
            setOpen(true)
          }}
        >
          Create New Domain VRD Message
        </button>
      </div>
      <Modal
        open={open}
        title={
          isEdit ? 'Edit Domain VRD Message' : 'Create New Domain VRD Message'
        }
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='back' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              if (Object.keys(validation.errors).length !== 0) {
                Object.keys(validation.errors).map(key => {
                  toast.error(validation.errors[key])
                })
                return
              }
              validation.handleSubmit()
            }}
          >
            Submit
          </Button>
        ]}
      >
        <div className='gap-8 '>
          <div className=' mb-3 flex-1'>
            <label className="form-label">Message</label>
            <Input
              type='text'
              name='msg'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.msg}
            />
            {validation.touched.msg && validation.errors.msg ? (
              <p className='text-danger'>{validation.errors.msg}</p>
            ) : null}
          </div>

          <div className=' mb-3 flex-1'>
            <label>Message Status</label>
            <br />
            <Select
              className={''}
              name='is_active'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.is_active}
              value={validation?.values?.is_active}
              onChange={e => validation.setFieldValue('is_active', e)}
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Active',
                  value: true
                },
                {
                  label: 'Inactive',
                  value: false
                }
              ]}
            />
            {validation.touched.status && validation.errors.status ? (
              <p className='text-danger'>{validation.errors.status}</p>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default EditCreateDomainVRDModal
